import React from 'react';
import logo from './logo.svg';
import './App.scss';

import RouterTemplate from './RouterTemplate';

function App() {
  return (
    <div>
      <RouterTemplate/>
    </div>
  );
}

export default App;
